import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Luxurious%20red%20and%20gold%20Chinese%20festive%20background%20with%20glowing%20lanterns%20and%20soft%20bokeh%20lights%2C%20warm%20elegant%20atmosphere%2C%20celebration%20theme%2C%20abstract%20geometric%20patterns%20in%20gold%2C%20dark%20rich%20texture%2C%20cinematic%20lighting%2C%20clean%20composition&width=1600&height=900&seq=hero-bg-main&orientation=landscape"
          alt="送彩金活动背景"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center max-w-[900px] mx-auto">
        <div className="inline-flex items-center gap-2 bg-accent-500/20 backdrop-blur-sm border border-accent-400/30 rounded-full px-4 py-1.5 mb-6">
          <i className="ri-fire-line text-accent-400 text-sm"></i>
          <span className="text-accent-300 text-sm font-medium">送彩金活动火热进行中</span>
        </div>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-4">
          送彩金
          <span className="block text-accent-400 mt-1">领取专属优惠彩金活动</span>
        </h1>
        <p className="text-base md:text-lg text-background-200 max-w-[650px] mx-auto mb-8 leading-relaxed">
          注册即可领取专属彩金，首存送彩金、签到送彩金、邀请好友送彩金等多种方式任你选择，
          彩金到账快速，提款无忧，立即参与赢取更多奖励！
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href="#cta"
            className="bg-primary-500 hover:bg-primary-600 text-background-50 px-8 py-3 rounded-full text-base font-semibold transition-all duration-200 whitespace-nowrap cursor-pointer w-full sm:w-auto"
          >
            立即注册领取彩金
          </a>
          <Link
            to="/category/first-deposit"
            className="bg-background-50/10 backdrop-blur-sm hover:bg-background-50/20 text-background-50 border border-background-50/30 px-8 py-3 rounded-full text-base font-medium transition-all duration-200 whitespace-nowrap cursor-pointer w-full sm:w-auto"
          >
            查看全部活动
          </Link>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-6 mt-10">
          {[
            { icon: 'ri-shield-check-line', text: '彩金秒到账' },
            { icon: 'ri-bank-card-line', text: '提款无忧' },
            { icon: 'ri-user-star-line', text: '千万玩家信赖' },
          ].map((item) => (
            <div key={item.text} className="flex items-center gap-2 text-background-300 text-sm">
              <i className={`${item.icon} text-accent-400`}></i>
              <span>{item.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}